import React, { useEffect, useState } from "react";
import { Modal, Form, Button, ListGroup } from "react-bootstrap";
import { toast } from "react-toastify";
import AdminApi from "../api/adminApi";
import RetreatApi from "../api/retreatApi";

interface RegistrationPasswordSendModalProps {
  show?: boolean;
  onHide: () => void;
  password?: string;
}

const RegistrationPasswordSendModal: React.FC<RegistrationPasswordSendModalProps> = ({ show, onHide, password }) => {
  const [passwordMailInput, setPasswordMailInput] = useState<string>("");
  const [passwordMailList, setPasswordMailList] = useState<string[]>([]);
  const [displayPassword, setDisplayPassword] = useState<string>(password || "");
  const adminApi = new AdminApi();
  const retreatApi = new RetreatApi();

  useEffect(() => {
    if (!show) return;
    if (password) {
      setDisplayPassword(password);
      return;
    }
    retreatApi
      .getPassword()
      .then((res: any) => {
        const next =
          res?.data?.password || res?.password || res?.data?.data?.password || "";
        setDisplayPassword(next);
      })
      .catch(() => setDisplayPassword(""));
  }, [show, password]);

  const handleAddPasswordMail = () => {
    const emailStr = passwordMailInput.trim();
    if (!emailStr) return;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailStr)) {
      toast.error("Invalid email address");
      return;
    }
    if (passwordMailList.includes(emailStr)) {
      toast.error("Email already added");
      return;
    }
    setPasswordMailList([...passwordMailList, emailStr]);
    setPasswordMailInput("");
  };

  const handleRemovePasswordMail = (index: number) => {
    const list = [...passwordMailList];
    list.splice(index, 1);
    setPasswordMailList(list);
  };

  const handleSendPasswordMail = async () => {
    if (passwordMailList.length === 0) {
      toast.error("Please add at least one email");
      return;
    }
    await adminApi
      .sendRegistrationPassword({ emails: passwordMailList })
      .then((res: any) => {
        if (res.success) {
          toast.success("Password sent successfully!");
          onHide();
          setPasswordMailList([]);
        } else {
          toast.error(res.msg || "Failed to send password.");
        }
      })
      .catch((err) => {
        toast.error("Failed to send password.");
      });
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Send Password for New Retreat Registration</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <p className="text-muted mb-3 mt-3">
          Add email addresses to send them the Registration Password for the New
          Retreat Registration page.
        </p>
        <div className="d-flex align-items-center mb-4">
          <Form.Control
            type="email"
            placeholder="Enter email address"
            value={passwordMailInput}
            onChange={(e) => setPasswordMailInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleAddPasswordMail();
              }
            }}
          />
          <Button
            variant="primary"
            className="ms-2 passwordMail"
            onClick={handleAddPasswordMail}
          >
            +
          </Button>
        </div>
        {passwordMailList.length > 0 && (
          <ListGroup>
            {passwordMailList.map((email, idx) => (
              <ListGroup.Item
                key={idx}
                className="d-flex justify-content-between align-items-center"
              >
                {email}
                <i
                  className="mdi mdi-delete text-danger"
                  style={{ cursor: "pointer", fontSize: "1.2rem" }}
                  onClick={() => handleRemovePasswordMail(idx)}
                ></i>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
                <p className="mt-2">
          Password : <strong>{displayPassword || "Loading..."}</strong>
        </p>
        <div className="text-center mt-4">
          <Button variant="primary" onClick={handleSendPasswordMail}>
            Send
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RegistrationPasswordSendModal;
